/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EnumAuditExtendAction = {
  Create: 'create',
  Update: 'update',
  Destroy: 'destroy'
} as const
export type EnumAuditExtendAction = typeof EnumAuditExtendAction[keyof typeof EnumAuditExtendAction]

export function EnumAuditExtendActionFromJSON(json: any): EnumAuditExtendAction {
  return EnumAuditExtendActionFromJSONTyped(json, false)
}

export function EnumAuditExtendActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumAuditExtendAction {
  return json as EnumAuditExtendAction
}

export function EnumAuditExtendActionToJSON(value?: EnumAuditExtendAction | null): any {
  return value as any
}
